import {actions as ROOT} from './root';
import {actions as PROGRESS} from './progress';
import {actions as STEPS} from './steps';
import {actions as QUESTIONS} from './questions';
import {actions as INPUTS} from './inputs';
import {actions as VALIDATION} from './validation';
import {actions as FILES} from './files';
import {actions as SERVICES} from './service';
import {actions as CONTEXT} from './context';
import {actions as REVIEW_METRICS} from './review-metrics';
import {actions as TAXONOMY} from './taxonomy';
import {actions as SERVICE_SELECTOR} from './service-selector';

export const actions = {
  ROOT,
  PROGRESS,
  STEPS,
  QUESTIONS,
  INPUTS,
  VALIDATION,
  FILES,
  SERVICES,
  CONTEXT,
  REVIEW_METRICS,
  TAXONOMY,
  SERVICE_SELECTOR,
};
